import React, { useMemo } from 'react';
import { Control, Controller, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { TitleFull } from '@warehouse/title/core';
import { TextInput } from '@warehouse/shared/legacy-ui';
import { getDryRanEditDescription } from '@warehouse/title/feature-create-titles';
import useTooltip from '../../../../src/utils/hooks/useTooltips';

interface EditDescriptionFieldProps {
	control: Control<any>;
	setValue: UseFormSetValue<any>;
	errors: FieldErrors<any>;
	dryRanTitle?: TitleFull | undefined;
}

export function EditDescriptionField({ control, errors, setValue, dryRanTitle }: EditDescriptionFieldProps) {
	const tooltip = useTooltip('coreMetadata.basic.versionIntent.descriptions');

	const inheritedDescription = getDryRanEditDescription(dryRanTitle);

	return useMemo(
		() => (
			<Controller
				name="editDescription"
				control={control}
				render={({ field }) => (
					<TextInput
						ariaLabel="Edit Description"
						label="Edit Description"
						placeholder={inheritedDescription}
						tooltip={tooltip?.tooltip}
						variant={!field.value ? 'prefilled' : 'default'}
						error={errors?.editDescription?.message as string}
						value={field.value}
						onChange={(e) => setValue('editDescription', e.target.value)}
					/>
				)}
			/>
		),
		[control, errors?.editDescription?.message, inheritedDescription, setValue, tooltip?.tooltip],
	);
}
